/* global siteurl, currentFilters, history,  baseURL, photosTotal, photosPerPage,
 photos */

import 'selectize';
import * as Handlebars from 'handlebars';
import { scrollToTop } from './common';

//window.selectize = require('selectize');


const $window = $(window);
const $sidebar = $('.c-gallery-sidebar');
const ajaxUrl = `${siteurl}photos`;
let isMobile = false;
let photosTemplate;
let paginationTemplate;
/*
 * array of objects in the form of
 * {
 *   id: filterId,
 *   name: filterType,
 *   value: filterTextValue
 *   el: $filterElement
 * }
 */

const filters = [];
let selectedFilter = {};
let selectizeInstance;
let selectizeControl;

let changedPage = false;
let currentPage = 1;
let pages;

const getURL = function () {
  const { protocol, host, pathname } = window.location;
  return `${protocol}//${host}${pathname}`;
};

const showSelectedMaxSize = function () {
  $('.js-size-filter__value').text($('.js-size-filter').val());
};
const addBoxes = function () {
  if (currentPage % 2 === 1 && (photosTotal / photosPerPage) > 60) {
    const el = $('.c-gallery');
    const projectBoxTemplate = $('#gallery-box-project-template').html();
    const projectBoxRendered = Handlebars.compile(projectBoxTemplate);
    const curatorsBoxTemplate = $('#gallery-box-curators-template').html();
    const curatorsBoxRendered = Handlebars.compile(curatorsBoxTemplate);
    el.append(projectBoxRendered);
    el.append(curatorsBoxRendered);
  }
};
const updateURL = function () {
  let newQueryString = $.param(filters, true);
  newQueryString = newQueryString.replace('%2', '&');
  console.log("newQueryString="+newQueryString);
  // const url = getURL();

  const url = getURL();

  if (history.pushState) {
    const newUrl = `${url}?${newQueryString}`;

    window.history.pushState({ path: newUrl }, '', newUrl);
  }
};
const displayPaginationArrow = function () {
  if (currentPage === 1) {
    $('.js-pagination-arrow.prev-page').addClass('is-inactive');
  } else {
    $('.js-pagination-arrow.prev-page').removeClass('is-inactive');
  }
  if (currentPage === pages) {
    $('.js-pagination-arrow.next-page').addClass('is-inactive');
  } else {
    $('.js-pagination-arrow.next-page').removeClass('is-inactive');
  }
};
const changePage = function () {
  if ($(this).hasClass('is-inactive')) {
    return;
  }
  const direction = $(this).data('direction');
  let newPage = currentPage;
  if (direction === 'prev' && currentPage > 1) {
    newPage = currentPage - 1;
  }
  if (direction === 'next') {
    newPage = currentPage + 1;
  }
  $('.js-gallery-pagination option').filter(function () {
    return parseInt(this.value, 10) === newPage;
  }).prop('selected', true);
  currentPage = newPage;
  $('.js-gallery-pagination').change();
};
const loadPaginationTemplate = function () {
  pages = Math.ceil(photosTotal / photosPerPage);
  const template = $('#pagination-template').html();
  const rendered = Handlebars.compile(template);
  paginationTemplate = rendered({ pages, total: pages, currentPage });
  $('.gallery-pagination').html(paginationTemplate);
};
const loadPhotosTemplate = function () {
  const view = { photos };
  const template = $('#gallery-photos-template').html();
  const rendered = Handlebars.compile(template);
  photosTemplate = rendered(view);
  mockupGalleryInteraction();
};
const doFilteredSearch = function () {
  $(".gallery-bodyclick").show();
  $.post(
    // this calls the gallery function in controller gallery
    getURL(),
    {
      changedPage,
      filters: filters.map(filter =>
        // this is to remove the key el from the filter objects,
        // otherwise it creates problem with jquery
        ({
          id: filter.id,
          name: filter.name,
          value: filter.value,
        })),
    },
    (jsonData) => {
      $(".gallery-bodyclick").hide();
      $(".amount-of-found-photos").html("("+jsonData.photos_total+")");

      photos = jsonData.photos;
      photosTotal = jsonData.photos_total;
      photosPerPage = jsonData.photosPerPage;
      if (!changedPage) {
        loadPaginationTemplate();
      }
      displayPaginationArrow();
      loadPhotosTemplate();
      changedPage = false;
      $('.c-gallery').html(photosTemplate);
      addBoxes();
      if (photosTotal == 0) {
        $('.no-photos-error-container').html($('.no-photos').html()).removeClass('is-hidden');
        $('.c-gallery').addClass('is-hidden');
        $('.gallery-pagination').addClass('is-hidden');
      } else {
        $('.no-photos-error-container').addClass('is-hidden');
        $('.c-gallery').removeClass('is-hidden');
        $('.gallery-pagination').removeClass('is-hidden');
      }
    },
    'json',
  );
};
const cleanUpSpecialChars = function (str) {
  str = str.replace(/[ÀÁÂÃÄÅ]/g, 'A');
  str = str.replace(/[àáâãäå]/g, 'a');
  str = str.replace(/[ÈÉÊË]/g, 'E');
  str = str.replace(/[ëèé]/g, 'e');
  str = str.replace(/[ö]/g, 'o');
  str = str.replace(/[ü]/g, 'u');
  return str;
  // str.replace(/[^a-z0-9]/gi, ''); // this removes any no-alphanumerical character
};
const prepareFilterValues = function (filter) {
  filter.text = `${filter.text}`;
  filter.text = filter.text.toLowerCase();
  filter.text = cleanUpSpecialChars(filter.text);
  if (filter.type !== 'style'
    && filter.type !== 'format'
    && filter.type !== 'color'
    && filter.type !== 'sort'
    && filter.type !== 'keyword') {
    filter.id = parseInt(filter.id, 10);
  }
};
const getFilterIndexByType = function (filterType) {
  return filters.findIndex(filter => filterType === filter.name);
};
const getFilterIndexByTypeAndId = function (filterType, filterId) {
  return filters.findIndex(filter => filterType === filter.name
    && filterId === filter.id);
};
const addFilterToList = function (filter) {
  if (filter.text != '') {
    filters.push({
      // this is the format accepted by $.param, with name and value as keys
      id: filter.id,
      name: filter.type,
      value: filter.text,
      el: filter.el,
    });
  }

};
const removeFilterByIndex = function (filterIndex) {
  if (filterIndex >= 0) {
    filters.splice(filterIndex, 1);
  }
};
const updateCurrentFiltersBox = function () {
  const template = $('#current-filters-template').html();
  const rendered = Handlebars.compile(template);
  const filtersTemplate = rendered({ filters });
  $('.js-current-filters').html(filtersTemplate);
  if (filters.length > 0) {
    $('.js-no-filters-text').hide();
  } else {
    $('.js-no-filters-text').show();
  }
};
const removeDisplayedFilter = function (filterIndex) {
  const filter = filters[filterIndex];
  if (filter.name === 'style') {
    filter.el.prop('checked', false);
  }
  if (filter.name === 'category') {
    filter.el.toggleClass('is-selected');
  }
  if (filter.name === 'format') {
    filter.el.toggleClass('is-selected');
  }
  if (filter.name === 'color') {
    filter.el.toggleClass('is-selected');
  }
  if (filter.name === 'country' ||
    filter.name === 'continent') {
    selectizeControl.clear(true);
  }
  if (filter.name === 'size') {
    $('.js-size-filter').val(0);
  }
  if (filter.name === 'keyword') {
    $('#keyword-list').val('');
  }
};
const onFilterDelete = function () {
  const $filterElement = $(this).closest('.c-active-filters__item');
  const filterType = $filterElement.data('filter-type');
  const filterId = $filterElement.data('filter-id');
  const filterIndex = getFilterIndexByTypeAndId(filterType, filterId);

  /* let pageFilterIndex = getFilterIndexByType('page');
        if (pageFilterIndex !== -1) {
            removeFilterByIndex(pageFilterIndex);
        }
        */

  // if it's a country or continent we alredy remove the filter here, when calling clear()
  removeDisplayedFilter(filterIndex);

  // in the case the filter is either country or continent,
  // these functions are already called in response
  // to self.clear event
  if (!(filterType === 'country' ||
    filterType === 'continent')) {
    removeFilterByIndex(filterIndex);
    updateURL();
    updateCurrentFiltersBox();
    doFilteredSearch();
  }
};
const updateFilterDisplay = function (filter) {
  if (filter.type === 'category') {
    $('.js-category-filter.is-selected').not(filter.el).removeClass('is-selected');
    filter.el.toggleClass('is-selected');
  }
  if (filter.type === 'format') {
    $('.js-format-filter.is-selected').not(filter.el).removeClass('is-selected');
    filter.el.toggleClass('is-selected');
  }
  if (filter.type === 'color') {
    //console.log(filter);
    //$('.js-color-filter.is-selected').not(filter.el).removeClass('is-selected');
    filter.el.toggleClass('is-selected'); 
  }
  if (filter.type === 'page') {
    // $('.js-format-filter.is-selected').not(filter.el).removeClass('is-selected');
    // filter.el.toggleClass('is-selected');
  }


  if (filter.type === 'sort') {
    if (isMobile) {
      $('.mobile-sort-label.is-selected').removeClass('is-selected');
      filter.el.parent().toggleClass('is-selected');
      $('.sort-by-mobile-value').text(filter.el.data('filter-text'));
    }
  }
};
/*
   It returns the index of the filter to remove or -1 if the filter isn't already in the list
*/
const isFilterAlreadySelected = function (newFilter) {

  let filterIndexToRemove;
  if (newFilter.type === 'style') {
    filterIndexToRemove = getFilterIndexByTypeAndId(newFilter.type, newFilter.id);
  } else {
    filterIndexToRemove = getFilterIndexByType(newFilter.type);
  }

  // const filterIndexToRemove =
  // return getFilterIndexByType(newFilter.type);
  return filterIndexToRemove;
};
const constructFilter = function (filterType, $filterElement) {
  let filterId;
  let filterText;
  switch (filterType) {
    case 'category':
      filterId = $filterElement.data('filter-id');
      filterText = $filterElement.attr('href'); //$filterElement.data('filter-value');
      break;
    case 'style':
    case 'color':
      filterId = $filterElement.data('filter-id');
      filterText = $filterElement.data('filter-value');
      break;
    case 'country':
    case 'continent':
      filterId = $filterElement.data('filter-id');
      filterText = $filterElement.data('filter-value');
      break;
    case 'size':
      filterId = parseInt($filterElement.val(), 10);
      filterText = $filterElement.val();
      break;
    case 'format':
      // We use the label here for both and then in php we convert
      // the label to the right database column value
      filterId = $filterElement.data('filter-label');
      filterText = $filterElement.data('filter-label');
      break;
    case 'page': {
      const selectedPage = $filterElement.find('option:selected');
      filterId = selectedPage.data('filter-id');
      filterText = selectedPage.data('filter-text');
      currentPage = parseInt(filterText, 10);
      break;
    }
    case 'sort': {
      let selectedSort;
      selectedSort = $filterElement.find('option:selected');
      /*
      if (isMobile) {
        selectedSort = $filterElement.filter(':checked');
        console.log(selectedSort);
      }
      else {
        selectedSort = $filterElement.find('option:selected');
        console.log('notMobile selectedSort='+selectedSort);
      }
      */
      filterId = selectedSort.data('filter-id');
      filterText = selectedSort.data('filter-value');
      break;
    }
    case 'keyword': {
      const $inputElement = $filterElement.find('#keyword-list');
      let keywords = $inputElement.val();
      if (keywords) {
        keywords = cleanUpSpecialChars(keywords);
        keywords = keywords.match(/[a-zA-Z0-9 -]/g).join('');
        keywords = keywords.trim();
      }

      filterId = keywords;
      filterText = keywords;
      $inputElement.data('filter-id', keywords);
      $inputElement.data('filter-text', keywords);
      break;
    }
  }
  selectedFilter = {
    type: filterType,
    id: filterId,
    text: filterText,
    el: $filterElement,
  };

};
const onFilterChange = function (e) {
  if (e.preventDefault) {
    e.preventDefault();
  }

  let $filterElement;
  if (this instanceof jQuery) {
    $filterElement = this;
  } else {
    $filterElement = $(this);
  }
  const pageFilterIndex = getFilterIndexByType('page');
  if (pageFilterIndex !== -1) {
    removeFilterByIndex(pageFilterIndex);
  }

  /* let keywordFilterIndex = getFilterIndexByType('keyword');
        if (keywordFilterIndex !== -1) {
            removeFilterByIndex(keywordFilterIndex);
        }
        */

  const { filterType } = e.data;

  if (filterType === 'page') {
    changedPage = true;
  } else {
    currentPage = 1;
  }
  constructFilter(filterType, $filterElement);
  updateFilterDisplay(selectedFilter);
  prepareFilterValues(selectedFilter);


  const filterIndex = isFilterAlreadySelected(selectedFilter);
  if (filterIndex === -1) {
    addFilterToList(selectedFilter);
  } else if (filters[filterIndex].id == selectedFilter.id) {
    removeFilterByIndex(filterIndex);
  } else {
    removeFilterByIndex(filterIndex);
    addFilterToList(selectedFilter);
  }

  // if (filterType === 'page' || filterType === 'sort' || !isMobile) {
  // if (filterType === 'page' || filterType === 'sort' ) 
  {
    updateCurrentFiltersBox();
    updateURL();
    doFilteredSearch();
  }
  /* Store the keyword inserted in the gallery sidebar */
  if (filterType === 'keyword') {
    $.post(`${siteurl}/ajax/storeKeywordSearch`, {
      keywords: selectedFilter.text,
    });
  }

  scrollToTop();
  mockupGalleryInteraction();
};
const initCountryFilter = function () {
  const selectedValue = $('.js-country-filter').val();
  // selectize = $('.js-country-filter').selectize();

  selectizeInstance = $('.js-country-filter').selectize({
    items: [selectedValue],
    maxOptions: 10,
    // options: 0,
    // dataAttr: 'data-extra',
    openOnFocus: false,
    //plugins: ['remove_button'],
    delimiter: ',',
    persist: false,
    create: false,

    render: {
      item(data, escape) {
//        console.log('inside render', data.filterType);
        // the class is used to position the remove button in the css
        return `<div class="selectize-input-item" data-filter-value="${data.filterValue}" data-filter-id="${data.filterId}" data-filter-type="${data.filterType}">${escape(data.text)}</div>`;
      },
    },

    onClear() {
      const countryFilterIndex = getFilterIndexByType('country');
      const continentFilterIndex = getFilterIndexByType('continent');
      if (countryFilterIndex !== -1) {
        removeFilterByIndex(countryFilterIndex);
      }
      if (continentFilterIndex !== -1) {
        removeFilterByIndex(continentFilterIndex);
      }
      const pageFilterIndex = getFilterIndexByType('page');
      if (pageFilterIndex !== -1) {
        removeFilterByIndex(pageFilterIndex);
      }
      updateURL();
      updateCurrentFiltersBox();
      doFilteredSearch();
    },
    onDelete() {
      const countryFilterIndex = getFilterIndexByType('country');
      const continentFilterIndex = getFilterIndexByType('continent');
      if (countryFilterIndex !== -1) {
        removeFilterByIndex(countryFilterIndex);
      }
      if (continentFilterIndex !== -1) {
        removeFilterByIndex(continentFilterIndex);
      }
      const pageFilterIndex = getFilterIndexByType('page');
      if (pageFilterIndex !== -1) {
        removeFilterByIndex(pageFilterIndex);
      }
      updateURL();
      updateCurrentFiltersBox();
      doFilteredSearch();
    },
    onChange() {
      const countryId = selectizeControl.getValue();
      let filterElement;
      if (countryId) {
        filterElement = selectizeControl.getItem(countryId);
        console.log(filterElement);
        console.log(filterElement.data('filterType'));
        if (Object.getOwnPropertyNames(filterElement).length > 0) {
          const e = {
            data: {
              filterType: filterElement.data('filter-type'),
            },
          };
          onFilterChange.call(filterElement, e);
        } else {
          onFilterDelete.call(filterElement);
        }
      }
    },
  });
  selectizeControl = selectizeInstance[0].selectize;
};
const applyFilters = function () {
  updateCurrentFiltersBox();
  updateURL();
  doFilteredSearch();
};

const hideSidebar = function () {
  $sidebar.removeClass('is-visible');
  $('.gallery-mobile-sidebar-overlay').removeClass('is-visible');
  $('body').removeClass('u-no-scroll');
};
const onApplyFilters = function () {
  applyFilters();
  hideSidebar();
};
const onHideSidebar = function () {
  hideSidebar();
  applyFilters();
};

function showSidebar() {
  $sidebar.addClass('is-visible');
  $('.gallery-mobile-sidebar-overlay').addClass('is-visible');
  $('body').addClass('u-no-scroll');
};
const onResize = function () {
  isMobile = $window.width() < 780;
  // hideSidebar();
};
const showSortFilterList = function () {
  $(this).find('ul').slideToggle();
};
const onMobileSortClick = function (e) {
  e.stopPropagation();
};
$window.resize(onResize);
onResize();
$('.js-apply-filters').click(function() {
  onApplyFilters();
  $(".filters-wrap").hide();
  $("#bodyclick").hide();
});
Handlebars.registerHelper('minus', (lValue, rValue) => lValue - rValue);

Handlebars.registerHelper('ifNotEqual', function (arg1, arg2, options) {
  return (arg1 !== arg2) ? options.fn(this) : '';
});
Handlebars.registerHelper('ifEqual', function (arg1, arg2, options) {
  return (arg1 == arg2) ? options.fn(this) : '';
});


Handlebars.registerHelper('repeat', function (times, opts) {
  let out = '';
  let i;
  const data = {};

  if (times) {
    for (i = 1; i <= times; i += 1) {
      data.index = i;
      out += opts.fn(this, {
        data,
      });
    }
  } else {
    out = opts.inverse(this);
  }

  return out;
});

initCountryFilter();
$.each(currentFilters, (filterType, filterValue) => {
  //console.log("aaaa: " + filterType + " : " + filterValue);
  const filtersLength = filterValue.length;
  for (let i = 0; i < filtersLength; i++) {
    const filterValueId = filterValue[i];
    let filterText;
    let $filterElement;
    if (filterType === 'category') {
      //$filterElement = $(`.js-category-filter[data-filter-id=${filterValueId}]`);
      //filterText = $filterElement.attr('href'); // $filterElement.data('filter-value');
      //console.log(filterText);
      return;
    }
    if (filterType === 'style') {
      $filterElement = $(`.js-style-filter[data-filter-id=${filterValueId}]`);
      filterText = filterValueId;
    }
    if (filterType === 'color') {
      filterText = filterValueId;
    }
    if (filterType === 'country' || filterType === 'continent') {
      // $filterElement = $('.js-country-filter').find(`[data-filter-id='${filterValueId}']`);
      $filterElement = selectizeControl.getItem(filterValueId);
      filterText = $filterElement.data('filter-value');
    }
    if (filterType === 'format') {
      $filterElement = $('.js-format-filter').find(`[data-filter-id='${filterValueId}']`);
      filterText = filterValueId;
    }
    if (filterType === 'size') {
      filterText = filterValueId;
      showSelectedMaxSize();
    }
    if (filterType === 'page') {
      filterText = filterValueId;
      currentPage = parseInt(filterText, 10);
    }
    if (filterType === 'keyword') {
      filterText = filterValueId;
    }
    if (filterType === 'sort') {
      filterText = filterValueId;
    }
    selectedFilter = {
      type: filterType,
      id: filterValueId,
      text: filterText,
      el: $filterElement,
    };

    prepareFilterValues(selectedFilter);
    addFilterToList(selectedFilter);
    updateCurrentFiltersBox();
  }
});
/*



loadPaginationTemplate();
displayPaginationArrow();
loadPhotosTemplate();
$('.c-gallery').html(photosTemplate);
addBoxes();

*/

$('.js-style-filter').on('change', { filterType: 'style' }, onFilterChange);
$('#keyword-filter').on('submit', { filterType: 'keyword' }, onFilterChange);

$('.js-current-filters').on('click', '.delete-filter', onFilterDelete);
$('.no-photos-error-container').on('click', '.delete-filter', onFilterDelete);

$('.gallery-pagination').on('change', '.js-gallery-pagination', { filterType: 'page' }, onFilterChange);
$('.gallery-pagination').on('click', '.js-pagination-arrow', changePage);

$('.js-category-filter').click({ filterType: 'category' }, onFilterChange);
$('.js-color-filter').change({ filterType: 'color' }, onFilterChange);
$('.js-size-filter').change({ filterType: 'size' }, onFilterChange);
$('.js-size-filter').on('input', showSelectedMaxSize);
$('.js-format-filter').click({ filterType: 'format' }, onFilterChange);

$('.js-sort-filter').change({ filterType: 'sort' }, onFilterChange);
$('.js-sort-mobile-filter').change({ filterType: 'sort' }, onFilterChange);
$('.js-sort-mobile-filter').click(onMobileSortClick);

$('.js-hide-gallery-sidebar').click(onHideSidebar);
$('.js-show-gallery-sidebar').click(showSidebar);
$('.js-show-sort-filters-mobile').click(showSortFilterList);


$.deparam = function (params, coerce) {
  let obj = {},
    coerce_types = { true: !0, false: !1, null: null };

  // Iterate over all name=value pairs.
  $.each(params.replace(/\+/g, ' ').split('&'), (j, v) => {
    let param = v.split('='),
      key = decodeURIComponent(param[0]),
      val,
      cur = obj,
      i = 0,

      // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
      // into its component parts.
      keys = key.split(']['),
      keys_last = keys.length - 1;

    // If the first keys part contains [ and the last ends with ], then []
    // are correctly balanced.
    if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
      // Remove the trailing ] from the last keys part.
      keys[keys_last] = keys[keys_last].replace(/\]$/, '');

      // Split first keys part into two parts on the [ and add them back onto
      // the beginning of the keys array.
      keys = keys.shift().split('[').concat(keys);

      keys_last = keys.length - 1;
    } else {
      // Basic 'foo' style key.
      keys_last = 0;
    }

    // Are we dealing with a name=value pair, or just a name?
    if (param.length === 2) {
      val = decodeURIComponent(param[1]);

      // Coerce values.
      if (coerce) {
        val = val && !isNaN(val) ? +val // number
          : val === 'undefined' ? undefined // undefined
            : coerce_types[val] !== undefined ? coerce_types[val] // true, false, null
              : val; // string
      }

      if (keys_last) {
        // Complex key, build deep object structure based on a few rules:
        // * The 'cur' pointer starts at the object top-level.
        // * [] = array push (n is set to array length), [n] = array if n is
        //   numeric, otherwise object.
        // * If at the last keys part, set the value.
        // * For each keys part, if the current level is undefined create an
        //   object or array based on the type of the next keys part.
        // * Move the 'cur' pointer to the next level.
        // * Rinse & repeat.
        for (; i <= keys_last; i++) {
          key = keys[i] === '' ? cur.length : keys[i];
          cur = cur[key] = i < keys_last
            ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : [])
            : val;
        }
      } else {
        // Simple key, even simpler rules, since only scalars and shallow
        // arrays are allowed.

        if ($.isArray(obj[key])) {
          // val is already an array, so push on the next value.
          obj[key].push(val);
        } else if (obj[key] !== undefined) {
          // val isn't an array, but since a second value has been specified,
          // convert val into an array.
          obj[key] = [obj[key], val];
        } else {
          // val is a scalar.
          obj[key] = val;
        }
      }
    } else if (key) {
      // No value was defined, so set something meaningful.
      obj[key] = coerce
        ? undefined
        : '';
    }
  });

  return obj;
};

// this function is only for the gallery, since it's called after every ajax request.
// remember to change it also in the function mockupInteraction() in common.js 
// which is used for all the other pages that use the mockups mouseover
const mockupGalleryInteraction = function () {
  $(".c-gallery").on('mouseenter', '.c-card__mockup', function() {
    $(this).css('background-image', 'url(' + $(this).data('src') + ')' );
  })
  $(".c-gallery").on('mouseleave', '.c-card__mockup', function() {
    $(this).css('background-image', 'none' );
  })
};
mockupGalleryInteraction();


$(".macro-category-js").click(function() {
  let macroCategoryId = $(this).data('macro-category-id');
  $("#sub-categories-for-"+macroCategoryId).slideToggle('fast');
})

$("#toggle-filters-section").click(function() {
  $("#bodyclick").show();
  $(".filters-wrap").show();
})
$("#bodyclick, #close-filters").click(function() {
  $("#bodyclick").hide();
  $(".filters-wrap").hide();
  $(".c-gallery-sidebar").addClass('mobile-hidden');
})
$("#toggle-categories-section").click(function() {
  $("#bodyclick").show();
  $(".c-gallery-sidebar").removeClass('mobile-hidden').animate({width: "18rem"}, 'fast');
})